import { createQueryKeys } from '@lukemorales/query-key-factory';
import { UserProfileService } from '../service';
export const userProfileQueries = createQueryKeys('userProfile', {
    getUser: {
        queryKey: null,
        queryFn: UserProfileService.getUser
    }
});
